import styled from "@emotion/styled";
import { ActionToolbar } from "./action-toolbar";

export const StyledLightboxContainer = styled.div`
  width: 100vw;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${({ theme }) => theme.spacing[6]};
  padding-top: calc(${({ theme }) => theme.spacing[6]} + env(safe-area-inset-top));
  padding-right: calc(${({ theme }) => theme.spacing[6]} + env(safe-area-inset-right));
  padding-bottom: calc(80px + env(safe-area-inset-bottom));
  padding-left: calc(${({ theme }) => theme.spacing[6]} + env(safe-area-inset-left));
  touch-action: none;
  overscroll-behavior: contain;
`;

export const StyledLightboxToolbar = styled(ActionToolbar)`
  position: absolute;
  bottom: calc(${({ theme }) => theme.spacing["5"]} + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
`;

export const StyledZoomLabel = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 39px;
  height: ${({ theme }) => theme.spacing["10"]};
  padding: 0 ${({ theme }) => theme.spacing["1"]};
  user-select: none;
`;
